// import Swiper JS
import Swiper from 'swiper';
import { FreeMode } from 'swiper/modules';
// import Swiper styles
import 'swiper/swiper-bundle.css';

document.addEventListener("DOMContentLoaded", () => {

  const commonSwiperOptions = {
    modules: [FreeMode],

    freeMode: {
      enabled: true,
      momentum: true,
      momentumRatio: 1,
      momentumVelocityRatio: 0.75,
      sticky: false,
    },

    mousewheel: {
      forceToAxis: true,
      sensitivity: 1,
    },

    simulateTouch: true,
    grabCursor: true,
  };

  document.querySelectorAll('.swiper').forEach((swiperEl) => {
    const spaceBetween = swiperEl.dataset.spaceBetween
      ? Number(swiperEl.dataset.spaceBetween)
      : 5;

    const spaceBetweenMobile = swiperEl.dataset.spaceBetweenMobile
      ? Number(swiperEl.dataset.spaceBetweenMobile)
      : spaceBetween;

    const updateEdgeFades = (swiper) => {
      const container = swiper.el.closest('.vertical-presentation-videos-container');
      if (!container) return;

      container.classList.toggle('at-start', swiper.isBeginning);
      container.classList.toggle('at-end', swiper.isEnd);
    };

    new Swiper(swiperEl, {
      ...commonSwiperOptions,
      slidesPerView: "auto",
      spaceBetween: spaceBetweenMobile,

      breakpoints: {
        768: {
          spaceBetween: spaceBetween,
        },
      },

      on: {
        init: updateEdgeFades,
        slideChange: updateEdgeFades,
        reachBeginning: updateEdgeFades,
        reachEnd: updateEdgeFades,
        fromEdge: updateEdgeFades,
        resize: updateEdgeFades,
      },
    });
  });

});
